export default "__VITE_ASSET__BxZbHZIU__"